import {
  LayoutDashboard,
  Users,
  FileText,
  BarChart2,
  Clock,
  Coffee,
  ClipboardList,
  Megaphone,
  Settings,
  MessageCircle,
  BadgeInfo,
  Bell,
} from "lucide-react";
import Dashboard from "../app/dashboard";
import EmployeeMangement from "../app/employeeManagement";
import TaskManagement from "../app/taskMangement";
import EmployeeAnalytic from "../app/employeeAnalytice";
import AttendanceTracking from "../app/attendanceTracking";
import BreakManagement from "../app/breakManegment";
import DailyActivity from "../app/dailyActivity";
import Announcements from "../app/announcements";
import LoginPage from "../app/auth";
import OtpVerification from "../app/auth/otpVerification";
import SetNewPassword from "../app/auth/setNewPassword";
import ForgotPassword from "../app/auth/forgotPassword";
import AddEditEmployee from "../app/employeeManagement/addEditEmployee";
import EmployeeProfile from "../app/employeeManagement/employeeProfile";
import AddEditTask from "../app/taskMangement/addEditTask";
import SubtasksPage from "../app/taskMangement/subtasksPage";
import AddEditForm from "../app/announcements/addForm";
import Chats from "../app/chats";
import AdminSetting from "../app/settings";
import CustomForm from "../app/customForm";
import AddEditCustomForm from "../app/customForm/addEditCustomForm";
import SubmittedForm from "../app/submittedForm";
import Notifications from "../app/notification";
import ArchivedEmployes from "../app/archivedEmployee";
import AttendanceAdjust from "../app/attendanceAdmin";
import AttendanceAdjustmentHistory from "../app/attendanceAdjustmentHistory";

const AUTH_ROUTES = [
  {
    id: 1,
    name: "Login",
    path: "/login",
    icon: LayoutDashboard,
    component: <LoginPage />,
  },
  {
    id: 2,
    name: "Forgot password",
    path: "/forgot-password",
    icon: LayoutDashboard,
    component: <ForgotPassword />,
  },
  {
    id: 3,
    name: "OTP Verification",
    component: <OtpVerification />,
    exact: "exact",
    path: "otp-verification",
  },
  {
    id: 4,
    name: "Set New Password",
    component: <SetNewPassword />,
    exact: "exact",
    path: "set-new-password",
  },
];

const ADMIN_ROUTES = [
  {
    id: 1,
    name: "Dashboard",
    path: "/",
    icon: LayoutDashboard,
    component: <Dashboard />,
  },
  {
    id: 2,
    name: "Employee Management",
    path: "/employee-management",
    icon: Users,
    component: <EmployeeMangement />,
  },
  {
    id: 3,
    name: "Add Employee",
    path: "/add-employee",
    icon: Users,
    component: <AddEditEmployee />,
    isHideMenu: true,
  },
  {
    id: 4,
    name: "Employee Profile",
    path: "/employee-profile",
    icon: Users,
    component: <EmployeeProfile />,
    isHideMenu: true,
  },

  {
    id: 3,
    name: "Task Management",
    path: "/task-management",
    icon: FileText,
    component: <TaskManagement />,
  },

  {
    id: 5,
    name: "Add Task",
    path: "/add-task",
    icon: FileText,
    component: <AddEditTask />,
    isHideMenu: true,
  },
  {
    id: 6,
    name: "Edit Task",
    path: "/edit-task/:id",
    icon: FileText,
    component: <AddEditTask />,
    isHideMenu: true,
  },
  {
    id: 61,
    name: "Task Subtasks",
    path: "/jobs/:jobId/subtasks",
    icon: FileText,
    component: <SubtasksPage />,
    isHideMenu: true,
  },
  {
    id: 7,
    name: "Employee Analytics",
    path: "/employee-analytics",
    icon: BarChart2,
    component: <EmployeeAnalytic />,
  },
  {
    id: 5,
    name: "Attendance Tracking",
    path: "/attendance-tracking",
    icon: Clock,
    component: <AttendanceTracking />,
  },
  {
    id: 56,
    name: "Adjust Attendance",
    path: "/attendance-adjust",
    icon: Clock,
    component: <AttendanceAdjust />,
  },
  {
    id: 57,
    name: "Adjustment History",
    path: "/adjustment-history",
    icon: Clock,
    component: <AttendanceAdjustmentHistory />,
    isHideMenu: true,
  },
  {
    id: 4,
    name: "Archived Employees",
    path: "/archived-employees",
    icon: Users,
    component: <ArchivedEmployes />,
  },
  // {
  //   id: 6,
  //   name: "Break Management",
  //   path: "/break-management",
  //   icon: Coffee,
  //   component: <BreakManagement />,
  // },
  // {
  //   id: 7,
  //   name: "Daily Activity Management",
  //   path: "/daily-activity-management",
  //   icon: ClipboardList,
  //   component: <DailyActivity />,
  // },
  {
    id: 8,
    name: "Announcements",
    path: "/announcements",
    icon: Megaphone,
    component: <Announcements />,
  },
  {
    id: 9,
    name: "Add Announcement",
    path: "/add-announcement",
    icon: Megaphone,
    component: <AddEditForm />,
    isHideMenu: true,
  },
  {
    id: 10,
    name: "Edit Announcement",
    path: "/edit-announcement/:id",
    icon: Megaphone,
    component: <AddEditForm />,
    isHideMenu: true,
  },

  {
    id: 11,
    name: "Chats",
    path: "/chats",
    icon: MessageCircle,
    component: <Chats />,
  },
  {
    id: 12,
    name: "Custom Form",
    path: "/custom-form",
    icon: FileText,
    component: <CustomForm />,
  },
  {
    id: 16,
    name: "Notifications",
    path: "/notifications",
    icon: Bell,
    component: <Notifications />,
  },
  {
    id: 13,
    name: "Add Custom Form",
    path: "/add-custom-form",
    icon: FileText,
    component: <AddEditCustomForm />,
    isHideMenu: true,
  },
  {
    id: 14,
    name: "Edit Custom Form",
    path: "/edit-custom-form/:id",
    icon: FileText,
    component: <AddEditCustomForm />,
    isHideMenu: true,
  },
  {
    id: 15,
    name: "Daily Activity Management",
    path: "/submitted-forms",
    icon: FileText,
    component: <SubmittedForm />,
  },

];

const GENERAL_ROUTES = [
  {
    id: 1,
    name: "Admin Settings & Controls",
    path: "/settings",
    icon: Settings,
    component: <AdminSetting />,
  },
  // {
  //   id: 2,
  //   name: "Help",
  //   path: "/help",
  //   icon: BadgeInfo,
  //   component: null,
  // },
];

export { ADMIN_ROUTES, AUTH_ROUTES, GENERAL_ROUTES };
